module.exports = __webpack_public_path__ + "img/banner.655e1340.png";